import { Injectable } from '@angular/core';
import { HttpClient , HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from '../../../utils/url-utils';
import { errorHandl, setFormData } from '../../../utils/network-utils';
@Injectable({
  providedIn: 'root'
})
export class DispatchCenterService {

  constructor(private http: HttpClient) {
  }


  getUnassignedTripDetail(id): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }

  getCameraImages(jobId,assignId): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + `fwas?assign=${assignId}&job=${jobId}`)
      .pipe(
        catchError(errorHandl)
      );
  }


  getTripDetails(id): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.GET_TRIP_DETAILS_URL + `/${id}`)
      .pipe(
        catchError(errorHandl)
      );

  }

  getAdjustmentDetail(jobId, isFromBilling) {
    const endpoint = isFromBilling ? urls.GET_ADJUSTMENT_DETAIL_TRIPSLOGS_URL : urls.GET_ADJUSTMENT_DETAIL_URL;
      return this.http.get<any>(urls.BASE_URL + endpoint +  jobId)
        .pipe(
          catchError(errorHandl)
        );
  }


  saveOdometer(endPoint, data) {
    // Previously getAdjustmentDetail
    if (data) {
      delete data['escort'];
      return this.http.put<any>(urls.BASE_URL + endPoint, data)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.get<any>(urls.BASE_URL + endPoint)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  saveTripAdjustment(jobId, payload, isFromBilling?) {
    const endpoint = isFromBilling ? urls.GET_ADJUSTMENT_DETAIL_TRIPSLOGS_URL : urls.GET_ADJUSTMENT_DETAIL_URL;

    return this.http.put<any>(urls.BASE_URL + endpoint + jobId, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getBrokerRate(endPoint) {
    return this.http.get<any>(urls.BASE_URL + urls.GET_BROKER_RATE_URL + endPoint)
      .pipe(
        catchError(errorHandl)
      );
  }

  getNotifications(date?): Observable<any> {
    let params = new HttpParams();
    if(date){
      params = params.append('startDate', date);
    }
    return this.http.get<any>(urls.BASE_URL + urls.NOTIFICATIONS_URL, {params})
      .pipe(
        catchError(errorHandl)
      );
  }

  getDriverTrips(driverId) {
    return this.http.put<any>(urls.BASE_URL + urls.GET_MANIFEST_TRIPS, {'driverId': driverId} )
      .pipe(
        catchError(errorHandl)

      );
  }

 getTripDetail
  getFareDetail(id): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.FARE_FORMULA + '/' + '?assignId=' + id)
      .pipe(
        catchError(errorHandl)
      );

  }

  getDashboardTrips(payload) {
    return this.http.post(urls.BASE_URL + "assigns/trips", payload);
  }
  
  getCompaniesTrips(payload): Observable<any> {

    return this.http.post<any>(urls.BASE_URL + urls.GET_OPERATIONS, payload)
      .pipe(
        catchError(errorHandl)
      );
  }
}
